import { DiagnosticsStackDeviceMainStructure } from '../remote-diagnostics-topology.model';
import { DiagnosticsStackGenericResponse } from '../remote-diagnostics.model';

export const BusTopologyPhaseOne_viair: DiagnosticsStackGenericResponse<
  DiagnosticsStackDeviceMainStructure[]
> = {
  type: 'BusTopologyPhaseOne',
  structure: [
    {
      TI: 'TI_7372763',
      name: 'Master Device',
      structure: [
        {
          RES: ' 62 01 79 37 33 37 32 37 36 33 31 32 33 34 35 36 37 38 39',
          request_parameter_name: 'PA_DataIdent',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ReadDataByIdent',
          ecu: 'LL_0000_Main_ECU_CAN01',
          requestDate: '2023-04-21T12:06:10.856+0000',
          ecuvariant: 'LL_0000_Main_ECU_CAN01',
          request_parameter_value: 'ViessmannIdentificationNumber',
          securitystatus: 'ECU is unlocked !!!',
          type: 'ECU response structure by parameter name and value',
          structure: [
            {
              semantic: 'SERVICE-ID',
              path: 'PA_ServiID',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_ServiID',
              value: '98',
            },
            {
              semantic: '',
              path: 'PA_DataIdent',
              unit: '',
              translationid: '',
              dopname: '2 Byte Text Table VDD-Greenbook',
              name: 'PA_DataIdent',
              value: 'ViessmannIdentificationNumber',
            },
            {
              semantic: '',
              path: 'PA_DataRecor',
              translationid: '',
              dopname: '2 Byte Table VDD Greenbook',
              name: 'PA_DataRecor',
              structure: [
                {
                  semantic: 'ITEMID',
                  path: 'PA_DataRecor/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  dopname: '7 Byte Identical ItemId',
                  name: 'PA_ItemId',
                  value: '7372763',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  path: 'PA_DataRecor/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Year',
                  value: '1',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  dopname: '5 Byte Identical ProcessCounter',
                  name: 'PA_ProceCount',
                  value: '23456',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfCountOne',
                  value: '7',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfTwo',
                  value: '8',
                },
                {
                  semantic: 'VALUE',
                  path: 'PA_DataRecor/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Check',
                  value: '9',
                },
              ],
            },
            {
              semantic: '',
              path: 'PA_RecorDataIdentCheck',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_RecorDataIdentCheck',
              value: '',
            },
          ],
          REQ: ' 22 01 79',
        },
        {
          name: 'Main ECU',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0016_VCU_CAN01',
              translationid: 'TI_LL_0016_VCU_CAN01',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5002244_0000',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanExternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanExternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_VCUMaster',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'VCUMaster',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Selec',
                          unit: '',
                          translationid: 'TI_Selection',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable VcuDeviceObjectProperties',
                          name: 'PA_Selec',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '16',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2244',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '153',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7372763',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '23456',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '7',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '8',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '9',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Additional ECUs',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0041_TCU_UART58',
              translationid: 'TI_LL_0041_TCU_UART58',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5042244_400200',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '58',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_InternalUart',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'InternalUart',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BackendGateway',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BackendGateway',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUM',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_BackeGatew',
                          unit: '',
                          translationid: 'TI_BackendGateway',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable BackendGateway',
                          name: 'PA_BackeGatew',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '41',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '504',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2244',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '48',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '41',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '400',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '200',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7949720',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00032',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '1',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '2',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          request_parameter_name: 'PA_ItemNumbe',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ProduDefin',
          ecu: 'LL_0000_Main_ECU_CAN01',
          bundleID: 'B_00028_VA300',
          request_parameter_value: '7372763',
          type: 'RequestStructureByParameterNameAndValue',
        },
      ],
    },
  ],
};
